import React from 'react';
import Types from 'prop-types';
import classNames from 'classnames';
import Items from './Items';
import Tabs from '../Tabs';
import NavTypes from '../../../NavTypes';
import { LocaleValues } from '../../../common/l10n';
import { HelpCentreTitle } from '../HelpCentreTitle/HelpCentreTitle';
var className = 'tw-public-nav__menu';
var Menu = function Menu(_ref) {
  var items = _ref.items,
    buttonItemsForNav = _ref.buttonItemsForNav,
    commonItemsForNav = _ref.commonItemsForNav,
    isOpen = _ref.isOpen,
    onToggle = _ref.onToggle,
    inverse = _ref.inverse,
    language = _ref.language,
    availableLanguages = _ref.availableLanguages,
    onLanguageChange = _ref.onLanguageChange,
    activePath = _ref.activePath,
    submenuItems = _ref.submenuItems,
    navType = _ref.navType,
    locale = _ref.locale,
    isPillNavigation = _ref.isPillNavigation,
    personalNavItems = _ref.personalNavItems,
    businessTabLink = _ref.businessTabLink,
    personalTabLink = _ref.personalTabLink,
    isCTAshown = _ref.isCTAshown,
    cta = _ref.cta,
    onLocaleChange = _ref.onLocaleChange,
    availableLocales = _ref.availableLocales,
    withCountrySelector = _ref.withCountrySelector;
  function onCloseMenu() {
    if (isOpen) {
      onToggle();
    }
  }
  return /*#__PURE__*/React.createElement("nav", {
    id: "navbar",
    className: classNames(className, isOpen ? 'is-open' : 'is-collapsed')
  }, navType === NavTypes.HELP_CENTRE ? /*#__PURE__*/React.createElement(HelpCentreTitle, null) : /*#__PURE__*/React.createElement(Tabs, {
    navType: navType,
    locale: locale,
    isPillNavigation: isPillNavigation,
    personalNavItems: items,
    items: personalNavItems,
    inverse: inverse,
    language: language,
    availableLanguages: availableLanguages,
    onLanguageChange: onLanguageChange,
    activePath: activePath
    // eslint-disable-next-line react/jsx-no-bind
    ,
    onCloseMenu: onCloseMenu,
    businessTabLink: businessTabLink,
    personalTabLink: personalTabLink,
    availableLocales: availableLocales,
    onLocaleChange: onLocaleChange,
    withCountrySelector: withCountrySelector
  }), !isPillNavigation && /*#__PURE__*/React.createElement(Items, {
    items: items,
    inverse: inverse,
    language: language,
    availableLanguages: availableLanguages,
    onLanguageChange: onLanguageChange,
    activePath: activePath,
    "data-testid": "mainmenu"
    // eslint-disable-next-line react/jsx-no-bind
    ,
    onCloseMenu: onCloseMenu,
    className: "tw-public-nav__main",
    locale: locale,
    availableLocales: availableLocales,
    onLocaleChange: onLocaleChange,
    withCountrySelector: withCountrySelector
  }), !!submenuItems.length && /*#__PURE__*/React.createElement(Items, {
    items: submenuItems,
    inverse: inverse,
    language: language,
    availableLanguages: availableLanguages,
    onLanguageChange: onLanguageChange,
    activePath: activePath,
    isSubMenu: true,
    "data-testid": "submenu"
    // eslint-disable-next-line react/jsx-no-bind
    ,
    onCloseMenu: onCloseMenu,
    locale: locale,
    availableLocales: availableLocales,
    onLocaleChange: onLocaleChange,
    withCountrySelector: withCountrySelector
  }), isPillNavigation && /*#__PURE__*/React.createElement(Items, {
    className: classNames('tw-public-nav__common', {
      'tw-public-nav__cta--hidden': isCTAshown && isPillNavigation,
      'tw-public-nav--fade-in': !isCTAshown
    }),
    items: commonItemsForNav,
    inverse: inverse,
    language: language,
    availableLanguages: availableLanguages,
    onLanguageChange: onLanguageChange,
    activePath: activePath
    // eslint-disable-next-line react/jsx-no-bind
    ,
    onCloseMenu: onCloseMenu,
    locale: locale,
    availableLocales: availableLocales,
    onLocaleChange: onLocaleChange,
    withCountrySelector: withCountrySelector
  }), /*#__PURE__*/React.createElement(Items, {
    className: classNames('tw-public-nav__cta', {
      'tw-public-nav__cta--hidden': isCTAshown && isPillNavigation,
      'tw-public-nav--fade-in': !isCTAshown
    }),
    items: buttonItemsForNav,
    language: language,
    inverse: !isPillNavigation === inverse,
    availableLanguages: availableLanguages,
    onLanguageChange: onLanguageChange,
    activePath: activePath,
    "data-testid": "buttonmenu"
    // eslint-disable-next-line react/jsx-no-bind
    ,
    onCloseMenu: onCloseMenu,
    locale: locale,
    availableLocales: availableLocales,
    onLocaleChange: onLocaleChange,
    withCountrySelector: withCountrySelector
  }), cta && isPillNavigation && /*#__PURE__*/React.createElement("a", {
    href: cta.url,
    className: classNames('tw-public-nav__cta-button btn btn-accent btn-priority-1 btn-sm', {
      'tw-public-nav__cta-button--hidden': !isCTAshown,
      'tw-public-nav--fade-in': isCTAshown
    })
  }, cta.label));
};
Menu.defaultProps = {
  inverse: true,
  activePath: undefined,
  submenuItems: [],
  isPillNavigation: false,
  cta: undefined,
  isCTAshown: false,
  availableLanguages: null,
  availableLocales: null,
  onLanguageChange: function onLanguageChange() {},
  onLocaleChange: function onLocaleChange() {},
  locale: '',
  withCountrySelector: false
};
export default Menu;